import './B2BPaper.css';

import React, { forwardRef } from 'react';
import { Paper, Typography } from '@mui/material';
import { generateClassName } from './helpers';

const B2BPaper = forwardRef(({ elevation = 1, title, children, className = null }, ref) => {
    return (
        <Paper elevation={elevation} className={generateClassName("b2b-paper", "-container-paper", className)}>
            {title && (
                <div className={generateClassName("b2b-paper", "-container-banner", className)} ref={ref}>
                    <Typography>{title}</Typography>
                </div>
            )}
            <div className={generateClassName("b2b-paper", "-container-content", className)}>
                {children}
            </div>
        </Paper>
    );
});

B2BPaper.displayName = 'B2BPaper';

export default B2BPaper;